import { BulkOperationsState } from "PFCore/services/bulk_operations";
import { Id } from "PFCore/types";

import { useBulkOperationsStatus } from "./use_bulk_operations_status";

export const BULK_OPERATION_TERMINAL_STATES = [
  BulkOperationsState.Completed,
  BulkOperationsState.PartiallyCompleted,
  BulkOperationsState.Failed
];

export const isBulkOperationTerminalState = (state: BulkOperationsState) =>
  BULK_OPERATION_TERMINAL_STATES.includes(state);

type UseBulkOperationTerminalStatusOptions = {
  enabled?: boolean;
};

export const useBulkOperationTerminalStatus = (
  bulkOperationId: Id,
  { enabled = true }: UseBulkOperationTerminalStatusOptions = {}
) => {
  const { data: statusData } = useBulkOperationsStatus(bulkOperationId, {
    enabled,
    refetchInterval: ({ state }) =>
      state.data?.state && isBulkOperationTerminalState(state.data.state) ? false : 2000
  });

  const isTerminal = !!statusData?.state && isBulkOperationTerminalState(statusData.state);

  return { statusData, isTerminal };
};
